module.exports = __webpack_public_path__ + "static/img/car.a0f2eec6.png";